const ChevronRightThin = () => {
  return (
    <svg viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.949219 10.4854L5.89897 5.5356L0.94922 0.585857" stroke="currentColor" />
    </svg>
  );
};

export default ChevronRightThin;
